"use strict";
export function logContextUpdate(contextName, newState, _isDatadogEnabled) {
  if (__DEV__) {
    return;
  }
}
